import Service from '@/utils/fetch'

export const getProductsDetail = (params, headers: any = {}) => {
  return Service.post({
    url: '/api/v1/h5/adapter/frontconfig/goodslist',
    data: params,
    headers,
  })
}
